import React, { Component, Fragment } from 'react'
import './PerformanceRow.css'

class CumPerfRow extends Component {
  formatPercent(number) {
    return number !== null ? `${parseFloat(number * 100).toFixed(2)}%` : '-'
  }
  formatDate(string) {
    return new Date(string).toLocaleDateString([], { timeZone: 'UTC' })
  }

  render() {
    const { fund, wtRegion } = this.props

    if (fund.stdPerformanceDaily === null) {
      return null
    }

    const hide = true
    const yearStart = new Date(new Date().getFullYear(), 0, 1)
    const yearStartISO = yearStart.toISOString()
    const hideYTD = yearStartISO <= this.props.fund.inceptionDate ? true : false

    return (
      <Fragment>
        <tr className='greyline'>
          <td width='70' className='textLeft'>
            {(() => {
              switch (fund.type) {
                case 'BMK':
                  return fund.ticker.toUpperCase();
                case 'BLEND':
                case 'COD':
                  return '-';
                default:
                  const url = fund.fundPageURL || fund.msUrl;
                  return (
                    <a className='tickerLink' href={url} target='_new'>
                      {fund.ticker}
                    </a>
                  );
              }
            })()}
          </td>
          {['BMK', 'WTIDX'].includes(fund.type) ? (
            <td width='300' className='textLeft'>
              {fund.name.replace(/&amp;/g, '&')}
            </td>
          ) : (
            <td width='300' className='textLeft'>
              {`${fund.name.replace(/&amp;/g, '&')} (NAV)`}
            </td>
          )}
          <td className='textCenter'>{this.formatDate(fund.inceptionDate)}</td>
          {wtRegion === 'US' && (
            <Fragment>
              <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].mtdNAV)}</td>
              <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].mos3NAV)}</td>
              <td className='textCenter'>{hideYTD === true ? '-' : this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].ytdNAV)}</td>
            </Fragment>
          )}
          <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].yrs1NAV)}</td>
          <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].yrs3NAV)}</td>
          <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].yrs5NAV)}</td>
          <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].yrs10NAV)}</td>
          {fund.type === 'BMK' ? <td className='textCenter'>-</td> : <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].inceptionNAV)}</td>}
          <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].commonPeriodNAV)}</td>
        </tr>
        {!hide && (
          <tr className='whiteline'>
            <td width='50' className='textLeft'>
              &nbsp;
            </td>
            <td width='300' className='textLeft'>
              {`${fund.name.replace(/&amp;/g, '&')} (MP)`}
            </td>
            {wtRegion === 'US' && (
              <Fragment>
                <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].mtdMP)}</td>
                <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].mos3MP)}</td>
                <td className='textCenter'>{hideYTD === true ? '-' : this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].ytdMP)}</td>
              </Fragment>
            )}
            <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].yrs1MP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].yrs3MP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].yrs5MP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].yrs10MP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].inceptionMP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformanceDaily.slice(-1)[0].commonPeriodMP)}</td>
          </tr>
        )}
      </Fragment>
    )
  }
}

export default CumPerfRow
